import Vue from "vue";
import Vuex from "vuex";

import auth from './modules/auth';
import period from "./modules/period";
import view from "./modules/view";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    period,
    view
  },
});
